"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSaleStatus = exports.SALE_STATUS_LABELS = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var types_1 = require("../../pool/types");
var index_1 = require("../../pool/utils/index");
exports.SALE_STATUS_LABELS = (_a = {},
    _a[types_1.SaleStatus.static] = "not prepared",
    _a[types_1.SaleStatus.preRegister] = "pre-registration",
    _a[types_1.SaleStatus.register] = "registration",
    _a[types_1.SaleStatus.init] = "opens soon",
    _a[types_1.SaleStatus.open] = "open",
    _a[types_1.SaleStatus.finished] = "finished",
    _a);
function getSaleStatus(sale) {
    var _a = (0, index_1.getSaleStartEnd)(sale), start = _a.start, end = _a.end;
    var _b = (0, index_1.getSaleRegisterStartEnd)(sale), registerStart = _b.registerStart, registerEnd = _b.registerEnd;
    var now = (0, dayjs_1.default)();
    var isSoldOut = (0, index_1.isSaleSoldOut)(sale);
    if ((now.isAfter(end) && sale.status !== types_1.SaleStatus.static) || isSoldOut) {
        return types_1.SaleStatus.finished;
    }
    if (registerStart && now.isBefore(registerStart)) {
        return types_1.SaleStatus.preRegister;
    }
    if (registerStart &&
        now.isAfter(registerStart) &&
        now.isBefore(registerEnd)) {
        return sale.reachedMinBaseAllocation
            ? types_1.SaleStatus.init
            : types_1.SaleStatus.register;
    }
    if (now.isAfter(start.add(10, "second")) && now.isBefore(end)) {
        return types_1.SaleStatus.open;
    }
    return sale.address ? types_1.SaleStatus.init : types_1.SaleStatus.static;
}
exports.getSaleStatus = getSaleStatus;
